import { html as l, when as o } from "@microsoft/fast-element";
const t = l`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 6.75C3 6.33579 3.33579 6 3.75 6H20.25C20.6642 6 21 6.33579 21 6.75C21 7.16421 20.6642 7.5 20.25 7.5H3.75C3.33579 7.5 3 7.16421 3 6.75ZM6 12C6 11.5858 6.33579 11.25 6.75 11.25H17.25C17.6642 11.25 18 11.5858 18 12C18 12.4142 17.6642 12.75 17.25 12.75H6.75C6.33579 12.75 6 12.4142 6 12ZM9 17.25C9 16.8358 9.33579 16.5 9.75 16.5H14.25C14.6642 16.5 15 16.8358 15 17.25C15 17.6642 14.6642 18 14.25 18H9.75C9.33579 18 9 17.6642 9 17.25Z"
      fill="currentColor"
    />
  </svg>
`, C = l`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      d="M3.75 6.75H20.25M6.75 12H17.25M9.75 17.25H14.25"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`, n = l`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.375 5.625C2.375 5.21079 2.71079 4.875 3.125 4.875H16.875C17.2892 4.875 17.625 5.21079 17.625 5.625C17.625 6.03921 17.2892 6.375 16.875 6.375H3.125C2.71079 6.375 2.375 6.03921 2.375 5.625ZM4.875 10C4.875 9.58579 5.21079 9.25 5.625 9.25H14.375C14.7892 9.25 15.125 9.58579 15.125 10C15.125 10.4142 14.7892 10.75 14.375 10.75H5.625C5.21079 10.75 4.875 10.4142 4.875 10ZM7.375 14.375C7.375 13.9608 7.71079 13.625 8.125 13.625H11.875C12.2892 13.625 12.625 13.9608 12.625 14.375C12.625 14.7892 12.2892 15.125 11.875 15.125H8.125C7.71079 15.125 7.375 14.7892 7.375 14.375Z"
      fill="currentColor"
    />
  </svg>
`, r = l`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.90002 4.4999C1.90002 4.16853 2.16865 3.8999 2.50002 3.8999H13.5C13.8314 3.8999 14.1 4.16853 14.1 4.4999C14.1 4.83127 13.8314 5.0999 13.5 5.0999H2.50002C2.16865 5.0999 1.90002 4.83127 1.90002 4.4999ZM3.90002 7.9999C3.90002 7.66853 4.16865 7.3999 4.50002 7.3999H11.5C11.8314 7.3999 12.1 7.66853 12.1 7.9999C12.1 8.33127 11.8314 8.5999 11.5 8.5999H4.50002C4.16865 8.5999 3.90002 8.33127 3.90002 7.9999ZM5.90002 11.4999C5.90002 11.1685 6.16865 10.8999 6.50002 10.8999H9.50002C9.8314 10.8999 10.1 11.1685 10.1 11.4999C10.1 11.8313 9.8314 12.0999 9.50002 12.0999H6.50002C6.16865 12.0999 5.90002 11.8313 5.90002 11.4999Z"
      fill="currentColor"
    />
  </svg>
`, s = l`
  ${o((e) => e._type === "outline", C)}
  ${o((e) => e._type === "solid", t)}
  ${o((e) => e._type === "mini", n)}
  ${o((e) => e._type === "micro", r)}
`;
export {
  s as barsSortTemplate
};
